if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if(event.detail.currentElement)
      {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
  
  customElements.define('media-gallery-swiper', class MediaGallerySwiper extends HTMLElement {
    constructor(){
      super()
      // Réplica en móvil del hide_variants de PC: el CSS que oculta las fotos
      // de otras variantes solo aplica a .product__media-item (galería desktop),
      // así que aquí filtramos los slides: foto de la variante seleccionada +
      // fotos no asociadas a variantes. Sin slides marcados, no cambia nada.
      this.wrapper = this.querySelector('.swiper-wrapper');
      this.allSlides = this.wrapper ? Array.prototype.slice.call(this.wrapper.children) : [];
      this.hasVariantSlides = this.allSlides.some(function (s) {
        return s.classList.contains('product__media-item--variant');
      });
      if (this.hasVariantSlides) {
        var active = this.allSlides.find(function (s) { return s.classList.contains('is-active'); }) || this.allSlides[0];
        this.renderSlides(active);
      }
      this.swiper = new Swiper('.swiper-product', {
          slidesPerView: 1,
          pagination: {
              el: '.swiper-product-pagination',
              clickable: true,
          },
          navigation: {
              nextEl: '.swiper-product-next',
              prevEl: '.swiper-product-prev',
          },
          slideChange: (e) => {
            console.log(e)
          }
      });
    }

    renderSlides(activeSlide){
      // El slide activo (foto de la variante) va primero, igual que el prepend
      // de setActiveMedia en la galería de PC; después las fotos genéricas.
      var visible = [];
      if (activeSlide) visible.push(activeSlide);
      this.allSlides.forEach(function (s) {
        if (s !== activeSlide && !s.classList.contains('product__media-item--variant')) visible.push(s);
      });
      this.wrapper.innerHTML = '';
      var w = this.wrapper;
      visible.forEach(function (s) { w.appendChild(s); });
    }

    changeSelectedSlide(mediaId){
      const id = "Slide-" + mediaId;

      if (this.hasVariantSlides) {
        var target = this.allSlides.find(function (s) { return s.getAttribute('id') === id; });
        if (target) {
          this.renderSlides(target);
          this.swiper.update();
          if (this.swiper.pagination) {
            this.swiper.pagination.render();
            this.swiper.pagination.update();
          }
          this.swiper.slideTo(0, 0);
          return;
        }
      }

      const slideIndex = this.getSlideIndexById(id);

      // Desplazar el slider al slide correspondiente
      this.swiper.slideTo(slideIndex);
    }

    getSlideIndexById(id) {
      const slides = this.swiper.slides;
      for (let i = 0; i < slides.length; i++) {
        const slideId = slides[i].getAttribute('id');
        if (slideId === id) {
          return i;
        }
      }
      return 0;
    }
  })
}
